import { CheckoutField, TextKey } from '@mews-distributor/common';
import { LocalizedText } from '@mews/framework';

import { PaymentCardFormSection } from '../PaymentCardFormSection';

import { PaymentCardNumber, PaymentCvv } from './components';

export const GenericPaymentCardFormSection = PaymentCardFormSection({
    renderPaymentCardNumber: () => (
        <PaymentCardNumber
            // @ts-expect-error $TSFixMeError: Type '{ name: CheckoutField; label: Element; autoComplete: string; }' is not assignable to type 'IntrinsicAttributes & O...
            name={CheckoutField.CardNumber}
            label={<LocalizedText textKey={TextKey.PaymentCardNumber} />}
            autoComplete="cc-number"
        />
    ),
    renderPaymentCvv: () => (
        <PaymentCvv
            // @ts-expect-error $TSFixMeError: Type '{ name: CheckoutField; label: Element; autoComplete: string; }' is not assignable to type 'IntrinsicAttributes & O...
            name={CheckoutField.CardCVV}
            label={<LocalizedText textKey={TextKey.PaymentCardCVV} />}
            autoComplete="cc-csc"
        />
    ),
});
